import PasswordInput from '@/core/components/inputs/PasswordInput/PasswordInput';

export default PasswordInput;
